<template>
  <div id="app">
    <section ref="mainheader">
      <div class="top-top-barre container-fluid">
        <div
          class="d-flex justify-content-between align-items-top d-md-none px-3"
        >
          <navigation
            :internationalRent="internationalRent"
            :internationalSell="internationalSell"
            screen="small"
            style="margin-top:2px"
          />
          <div class="mt-1">
            <a
              class=""
              target="blank"
              href="https://www.facebook.com/pvnrealestate/"
            >
              <img
                class=" "
                src="/images/facebook-white.png"
                style="max-width:20px;"
                alt=""
            /></a>
            <a
              class="ml-3"
              target="blank"
              href="https://www.instagram.com/pvnrealestate/"
            >
              <img
                class=""
                src="/images/insta-white.png"
                style="max-width:20px;"
                alt=""
            /></a>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row d-flex align-items-center mt-1 mt-md-3">
          <div
            class="offset-md-4 col-md-4 offset-lg-4 col-lg-4 d-flex flex-row justify-content-center"
          >
            <router-link class="nav-link container-logo" to="/">
              <img
                class="logo img-fluid pointer"
                src="/images/logo-pvn.png"
                alt=""
              />
            </router-link>
          </div>
          <div class="col-lg-12 col-xl-3 d-none d-md-block">
            <div class="d-flex flex-row justify-content-center">
              <div class="text-right">
                <a class="color-black" href="tel:+37797707020"
                  >+377 97 70 70 20</a
                ><br />
                <a class="color-black" href="mailto:pvnrealestate@monaco.mc"
                  >pvnrealestate@monaco.mc</a
                >
              </div>
              <a
                class="mt-2 ml-3"
                target="blank"
                href="https://www.facebook.com/pvnrealestate/"
              >
                <img
                  class=" "
                  src="/images/facebook.png"
                  style="max-width:32px;"
                  alt=""
              /></a>
              <a
                class="mt-2"
                target="blank"
                href="https://www.instagram.com/pvnrealestate/"
              >
                <img
                  class="  ml-2"
                  src="/images/insta.png"
                  style="max-width:32px;"
                  alt=""
              /></a>
            </div>
            <!-- <div class="row container-right">
              <div
                class="container-coordonees col-md-12  col-lg-8 d-flex flex-column bis "
              >
                <div>
                  <a class="color-black" href="tel:+37797707020"
                    >+377 97 70 70 20</a
                  >
                </div>
                <div>
                  <a class="color-black" href="mailto:pvnrealestate@monaco.mc"
                    >pvnrealestate@monaco.mc</a
                  >
                </div>
              </div>
              <div class="col-md-12 col-lg-4 container-link-reseau">
                <a
                  class="link-reseau"
                  target="blank"
                  href="https://www.facebook.com/pvnrealestate/"
                >
                  <img
                    class=" "
                    src="/images/facebook.png"
                    style="max-width:54px;"
                    alt=""
                /></a>
                <a
                  class="link-reseau"
                  target="blank"
                  href="https://www.instagram.com/pvnrealestate/"
                >
                  <img
                    class="  ml-2"
                    src="/images/insta.png"
                    style="max-width:54px;"
                    alt=""
                /></a>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <navigation
        :internationalRent="internationalRent"
        :internationalSell="internationalSell"
        screen="big"
        class="d-none d-md-block"
      />
      <div
        style="background-color:red; height:10px; margin-top:5px"
        class="d-md-none"
      ></div>
    </section>
    <div class="">
      <loading class="container-loader" v-if="$root.loading"></loading>
      <router-view v-else />
    </div>

    <footer>
      <div class="container">
        <div class="row d-flex align-items-center ">
          <div class="col-md-12 col-lg-10">
            <div class="row ">
              <div
                class="container-coordonees col-md-12  col-lg-9 d-flex flex-column  small-text link-footer"
              >
                <div class="text-md-left mb-md-3">
                  <a class="color-white" href="tel:+37797707020"
                    >+377 97 70 70 20</a
                  ><br />
                  <a class="color-white" href="mailto:pvnrealestate@monaco.mc"
                    >pvnrealestate@monaco.mc</a
                  >
                </div>
                <hr class="hr-white hr-small w-100 d-md-none" />
                <div class="color-white text-left">
                  Copyright PVN Real Estate Investments
                </div>
                <div>
                  <ul
                    class="navbar-nav d-flex flex-row flex-wrap align-items-center  "
                  >
                    <li class="nav-item mr-1">
                      <router-link
                        class="nav-link small-text link-footer"
                        to="/"
                      >
                        {{ $t("translation.Accueil") }}
                      </router-link>
                    </li>
                    <span class="color-white">|</span>
                    <li class="nav-item mx-1">
                      <router-link
                        class="nav-link small-text link-footer"
                        to="/sitemap"
                      >
                        {{ $t("translation.Plan_du_site") }}
                      </router-link>
                    </li>
                    <span class="color-white">|</span>
                    <li class="nav-item mx-1">
                      <router-link
                        class="nav-link small-text link-footer"
                        to="/partners"
                      >
                        {{ $t("translation.Partenaires") }}
                      </router-link>
                    </li>
                    <span class="color-white">|</span>
                    <li class="nav-item mx-1">
                      <router-link
                        class="nav-link small-text link-footer"
                        to="/agence"
                      >
                        {{ $t("translation.Lagence") }}
                      </router-link>
                    </li>
                    <span class="color-white">|</span>
                    <li class="nav-item mx-1">
                      <router-link
                        class="nav-link small-text link-footer"
                        to="/legalnotice"
                      >
                        {{ $t("translation.legalnotice") }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-2 col-lg-2 d-flex flex-row justify-content-center">
            <!-- <a
              href="https://apps.apple.com/app/knight-frank-property-search/id350149855"
              target="blank"
            >
              <img class="logo ml-4" src="/images/footer-appstore.png" alt="" />
            </a> -->
          </div>
          <div class="col-md-3  col-lg-5"></div>
        </div>
      </div>
    </footer>
    <m-message-dialog
      v-model="$store.state.dialogErr"
      title="Erreur"
      :text="$store.state.dialogErrTxt"
      @close="$store.dispatch('showDialogError', false)"
    ></m-message-dialog>
    <div class="alertcookie" v-if="alertcookieshow">
      <div class="d-flex">
        <div>
          <h3>{{ $t("translation.vie_privee_title") }}</h3>
          <p>
            {{ $t("translation.vie_privee_txt") }}
            <router-link class="ml-2" to="/legalnotice">
              {{ $t("translation.legalnotice") }}
            </router-link>
          </p>
        </div>
        <div>
          <button class="btn btn-primary" @click="deleteAlertCookie">
            {{ $t("translation.Jaccepte") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
import "@fullcalendar/list/main.css";
// import Vue from "vue";
// import OfferDetails from "./views/OffersDetails";
// Vue.component("offer-details", OfferDetails);

export default {
  name: "App",
  components: {},
  data() {
    return {
      alertcookieshow: false,
      confirmLogoutDialog: false,
      drawer: true,
      nbClientSuivi: 0,
      nbBienSuivi: 0,
      //user: null,
      search: "",
      routeActive: this.$route.meta.menu,
      internationalRent: false,
      internationalSell: false
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  watch: {
    $route(to, from) {
      this.routeActive = this.$route.meta.menu;
    }
  },
  async mounted() {
    // cookies
    let ok = this.$cookie.get("belsunce_allertcookie");
    if (!ok || ok != "ok") this.alertcookieshow = true;

    // get offer internationnales pour savoir s'il faut afficher dans le menu
    let params = { international: true };
    let response = await this.$axios.get(
      this.$config.server_url + "/web/1.0/offers",
      { params }
    );
    if (!response || !response.data) return;
    let offers = response.data.data;
    // console.log("offers", offers);
    // trier les rent et les sell
    let offerRent = offers.filter(offer => {
      return offer.of_rent;
    });
    let offerSell = offers.filter(offer => {
      return offer.of_sell;
    });
    if (offerRent.length) this.internationalRent = true;
    if (offerSell.length) this.internationalSell = true;
  },
  destroyed() {},
  methods: {
    deleteAlertCookie() {
      this.alertcookieshow = false;
      this.$cookie.set("belsunce_allertcookie", "ok", 100);
    },
    // openWinContact(co_id) {
    //   this.$refs.contactwinedit.open(co_id);
    // },

    // resizeMainContainer() {
    //   if (!this.$refs.mainContainer) return;
    //   // if (this.$route.name == "login") {
    //   //   this.$refs.mainContainer.style.height = "100%";
    //   //   return;
    //   // }
    //   this.$refs.mainContainer.style.height =
    //     parseInt(window.innerHeight) - 64 + "px";
    // },
    go(where) {
      this.deleteResearch();
      this.$router.push(where);
    },
    deleteResearch() {
      this.search = "";
    },

    saveWinUser() {
      // console.warn("this.$store.state.user.co_name", this.$store.state.user);
      // this.$refs.modal1.close();
    },
    openWinUser() {
      this.$refs.modal1.open();
    },
    closeWinUser() {
      this.$refs.modal1.close();
    }
  }
};
</script>
<style lang="scss">
@import "../node_modules/bootstrap/scss/bootstrap.scss";
@import "./scss/styles.scss";
// voir : /node_modules/bootstrap/scss/_variables.scss";
.container-loader {
  height: 60vh;
}
.container-logo {
  width: 60%;
}
/********** section du haut ***********/
.top-top-barre {
  padding: 3px 0;
  background-color: #201f1f;
}
// top - barre
// .logo {
//   // width: 100%;
//   // max-width: 350px;
// }
.container-right {
  margin-top: 15px;
}
.container-coordonees {
  text-align: center;
}
.link-reseau img {
  width: 8%;
  margin-top: 8px;
  margin-bottom: 5px;
}
.container-link-reseau {
  text-align: center;
}
.navbar {
  padding: 0;
}

// barre de navigation
.container-nav {
  .navbar-light .navbar-nav .nav-link {
    color: #fff; // couleur texte
  }
  .nav-link {
    font-size: 17px;
    margin: 0;
    padding: 0.5rem 2rem;
  }
  .nav-link-lang {
    margin: 0 20px;
    a {
      font-size: 17px;
      color: #fff;
      text-decoration: none;
    }
    a:hover {
      color: black;
    }
    .dropdown2-item {
      color: #fff;
    }
    .dropdown2-item:active {
      background-color: black;
      color: #fff;
    }
  }
}
.coeur {
  width: 15px;
  height: 15px;
}
/************ footer **************/
.hr-white {
  border-top: 1px solid #f7f7f73d;
}
.hr-small {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
footer {
  background-color: #201f1f;
  padding: 10px;
  //margin-top: 100px;
  a:hover {
    color: black;
  }
}
.footer-logo {
  padding-top: 90px;
  margin: 40px;
}
.footer-titre {
  color: $color-blue2;
  text-transform: uppercase;
}
.alertcookie {
  max-height: 400px;
  overflow: auto;
  position: fixed;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 20px 60px;
  border-top: 3px solid black;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}
.container-right {
  margin-bottom: 10px;
}
.nav-link {
  color: #fff;
  font-weight: 300;
  font-family: $font-nunito;
  font-size: 20px;
  padding: 0;
}
.nav-link:hover {
  color: #d6d6d6;
}
.link-footer {
  font-family: $font-nunito;
}

///// navbar
.nav-item {
  cursor: pointer;
}
.container-nav .navbar-light .navbar-nav .nav-item-hover:hover {
  color: red;
}
.container-nav .navbar-light .navbar-nav .nav-item-hover-over {
  color: black;
}
/* .dropdown2 .dropdown2-menu {
    padding: 0 50px 10px;
  } */
.dropdown2 {
  position: relative;
  .dropdown2-menu {
    position: relative;
    background-color: #d71e29;
    padding: 0 10px 10px 40px;
    color: white;
    min-width: 170px;
  }
  .dropdown2-item {
    display: block;
    padding: 4px 10px;
    color: white;
  }
  .dropdown2-item:hover {
    background-color: black;
  }
}

@media (min-width: 768px) {
  .container-nav .navbar-light .navbar-nav .nav-item-hover:hover {
    color: black;
  }
  .link-reseau {
    width: 5%;
  }
  .top-top-barre {
    height: 10px;
    padding: 0;
  }
  .container-logo {
    width: 80%;
  }
  .container-nav .nav-link {
    margin: 0 30px;
  }
  .dropdown2 {
    .dropdown2-menu {
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      z-index: 20;
      background-color: #d71e29;
      padding: 20px 0;
      color: white;
      border: 0;
    }
  }
}
@media (min-width: 992px) {
  .container-right {
    margin-bottom: 0;
  }
}
@media (min-width: 992px) {
  .container-coordonees {
    text-align: right;
  }
  .container-right {
    margin-top: 0;
  }
  .link-reseau {
    width: 80%;
    margin-top: 0;
    margin-bottom: 0;
  }
  .link-reseau img {
    width: 100%;
    margin-top: 0;
    margin-bottom: 0;
    padding: 5px;
  }
  .container-link-reseau {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
}
</style>
